var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.002 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.001,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20.002,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.002,
    y: 10.001,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.074,
    y: 2.928,
    width: 4,
    height: 4,
    transform: "translate(2.105 14.937) rotate(-45.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.93,
    y: 2.928,
    width: 4,
    height: 4.001,
    transform: "translate(-2.041 4.929) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.93,
    y: 17.071,
    width: 4,
    height: 4,
    transform: "translate(-12.043 9.074) rotate(-45.008)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.073,
    y: 17.071,
    width: 4,
    height: 4,
    transform: "translate(-7.899 19.082) rotate(-45.02)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5d25b00b78d9be4adbd78611950b51cc.svg";
export { ForwardRef as ReactComponent };